import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function AddBannedItem() {
  const navigate = useNavigate();
  const [form, setForm] = useState({name: '', reason: '', addedBy: ''});

  const set = (field) => (e) => setForm(f => ({...f, [field]: e.target.value}));

  const handleSubmit = (e) => {
    e.preventDefault();
    api('/banned-items', {method: 'POST', body: JSON.stringify(form)})
      .then(r => r.ok ? r.json() : null)
      .then(item => { if (item) navigate(`/banned-list/${item.id}`, {state: {saved: true}}); });
  };

  return (
    <Layout>
      <Link to="/banned-list" className="text-rose-600 hover:text-rose-800 mb-4 inline-block">&larr; Back</Link>
      <div className="bg-white rounded-lg shadow p-6 max-w-2xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Add to Banned List</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
            <input type="text" required value={form.name} onChange={set('name')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Reason *</label>
            <textarea required value={form.reason} onChange={set('reason')} rows={3}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Added By *</label>
            <input type="text" required value={form.addedBy} onChange={set('addedBy')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-rose-500" />
          </div>
          <div className="flex gap-3">
            <button type="submit" className="px-6 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700">Save</button>
            <Link to="/banned-list" className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</Link>
          </div>
        </form>
      </div>
    </Layout>
  );
}
